import { Box, Stack } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { TableHelper } from "helpers";
import { useRequest } from "hooks/useRequest";
import { IZoneReport } from "model";
import React, { useState } from "react";
import { ReportApiService } from "services";
import { I18nTranslator, translations } from "utils/i18n";

const Zones = () => {
  const [getZoneRequest] = useState({});
  const { loading, data } = useRequest<{}, IZoneReport[]>(
    getZoneRequest,
    ReportApiService.getAllZonesReport
  );

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "zoneName",
      headerName: I18nTranslator(translations.report.zoneName),
      size: "medium",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "total",
      headerName: I18nTranslator(translations.report.totalLocation),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "checkedLocation",
      headerName: I18nTranslator(translations.report.checkedLocation),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "emptyLocation",
      headerName: I18nTranslator(translations.report.emptyLocation),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.report.description),
      size: "full",
      align: "left",
    }),
  ];

  return (
    <DataGrid
      loading={loading}
      rows={
        data
          ? data.map((item, index) => {
              return {
                ...item,
                no: index + 1,
              };
            })
          : []
      }
      columns={COLUMNS}
      disableSelectionOnClick
      hideFooter
      rowHeight={40}
      hideFooterPagination
      hideFooterSelectedRowCount
      getRowId={(row) => row.no}
      style={{ backgroundColor: "white" }}
      components={{
        NoRowsOverlay: () => (
          <Stack height="100%" alignItems="center" justifyContent="center">
            {I18nTranslator(translations.table.noData)}
          </Stack>
        ),
      }}
    />
  );
};

export default Zones;
